import axios from 'axios';

/**
 * Implements a data fetcher using Axios - replace with your favorite
 * SSR-capable HTTP or fetch library if you like. See HttpJsonFetcher<T> type
 * in sitecore-jss library for implementation details/notes.
 * @param {string} url The URL to request; may include query string
 * @param {any} data Optional data to POST with the request.
 */

// const axiosInstance = axios.create()
// CUSTOM CODE - This is a big issue in JSS AJAX calls and analytics:
// All analytics tracking such as page visit, page events, campaign trigger is done at the Sitecore Content API
// However the APP is making AJAX calls to the API. If on the same domain then it is all fine 
// BUT when on different domain the cookies for ANALYTICS and ASPNET session for the API domain cannot be set - and so refresh on every API call
// This make the sitecore analytics tracking impossible
// The line 25 - is required but not enough in new browsers...
// The withCredentials is required as well - this will allow the access-control-allow-credentials = true from the response to set the cookies for this API domain
const axiosInstance = axios.create({
  withCredentials: true,
})
export function dataFetcher(url, data) {
  return axiosInstance({
    url,
    method: data ? 'POST' : 'GET',
    data,
    // note: axios needs to use `withCredentials: true` in order for Sitecore cookies to be included in CORS requests
    // which is necessary for analytics and such
    crossdomain: true,
  });
}
